import { TFunction } from 'i18next'
import { AlertCircle, Info, Loader2 } from 'lucide-react'
import { FormItem, Tooltip } from 'vnetwork-ui'
import { CustomerPhoneExistsResponse } from '@/modules/Customer/services'

interface StepContactInfoProps {
    control: any
    t: TFunction
    phoneChecking?: boolean
    phoneMatchesLead?: boolean
    phoneExistsResult?: CustomerPhoneExistsResponse | null
}

/**
 * Step 3: Contact information
 */
const StepContactInfo = ({
    control,
    t,
    phoneChecking,
    phoneMatchesLead,
}: StepContactInfoProps) => (
    <div className="space-y-4">
        <div className="grid md:grid-cols-2 gap-4">
            <div data-tour="customer-name">
                <FormItem
                    control={control}
                    name="customer.customer_name"
                    type="textfield"
                    label={t('customer_name')}
                    placeholder={t('customer_name')}
                />
            </div>

            <div data-tour="customer-phone">
                <div className="relative">
                    <FormItem
                        control={control}
                        name="customer.customer_phone"
                        type="textfield"
                        label={t('employee_phone_number')}
                        placeholder={t('employee_phone_number')}
                    />
                    <div className="absolute right-2 top-9 pointer-events-none">
                        {phoneChecking && (
                            <Loader2 className="w-4 h-4 animate-spin text-gray-400" />
                        )}
                        {!phoneChecking && phoneMatchesLead && (
                            <AlertCircle className="w-4 h-4 text-red-500" />
                        )}
                    </div>
                </div>
                {!phoneChecking && phoneMatchesLead && (
                    <p className="text-red-500 text-xs mt-1 flex items-center gap-1">
                        {t('phone-exists-in-contact-sources')}
                        <Tooltip
                            title={t('phone-exists-in-contact-sources-tooltip')}
                        >
                            <Info className="w-3.5 h-3.5 text-red-400 cursor-help" />
                        </Tooltip>
                    </p>
                )}
            </div>

            <div data-tour="customer-position">
                <FormItem
                    control={control}
                    name="customer.customer_position"
                    type="textfield"
                    label={t('position_id')}
                    placeholder={t('position_id')}
                />
            </div>

            <FormItem
                control={control}
                name="customer.customer_dob"
                type="datepicker"
                label={t('customer_dob')}
            />
        </div>

        <FormItem
            control={control}
            name="customer.customer_note"
            type="textarea"
            label={t('note')}
            placeholder={t('note')}
        />
    </div>
)

export default StepContactInfo
